module.exports = __webpack_public_path__ + "img/bg_3.9dad26d7.png";